import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { PhxSheetComponent } from './phx-sheet.component';

@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [PhxSheetComponent],
  exports: [PhxSheetComponent],
})
export class PhxSheetModule {}
